goog.provide("shadow.js.shim.module$$mui$material$Modal$default");
shadow.js.shim.module$$mui$material$Modal$default = shadow.js.shim.module$$mui$material$Modal.default;
